import type { UserPermissions } from '../users/dto/user-permissions.dto'

export class Token {
    token: string
    iat: number
    exp: number
    userId: string
    companyId: string
    permissions: UserPermissions
}
